import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: max-content;
  flex-direction: column;
  background-color:  var(--grey-grey-100, #F5F5F5);
  padding: 24px;
  gap: 2px;
`;

export const SkeletonHeader = styled.div`
  display: flex;
  height: 52px;
  width: 100%;
  background-color: #fafafa;
  align-items: center;
  padding-inline: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  justify-content: space-between;
`;

export const SkeletonColumn = styled.div`
  display: flex;
  width: ${({width}) => width || '16px'};
  justify-content: flex-start;
`;

export const SkeletonRow = styled.div`
  display: flex;
  height: 60px;
  width: 100%;
  background-color: #fff;
  align-items: center;
  padding-inline: 16px;
  justify-content: space-between;
`;
